import { Footer } from "antd/lib/layout/layout";
import styled from "styled-components";

export const Container = styled.div<{
  $isFluid?: boolean;
  $isFullWidth?: boolean;
}>`
  width: 100%;
  margin: 0;

  ${({ $isFluid }) =>
    $isFluid &&
    `
    width: auto;
    margin: 0px 16px 50px 16px;
    padding: 0;
    @media (min-width: 1200px) {
      margin: 0px 136px 50px 136px;
      padding: 0;
    }
    @media (max-width: 1199px) { /* Tablet adjustments */
       margin: 0px 0px 50px 0px;
    }
  @media (max-width: 768px) {
      margin: 0px 16px 0px 16px;
      padding: 0;
    }
  `}

  ${({ $isFullWidth }) =>
    $isFullWidth &&
    `
    margin: 0;
    padding: 0;
    width: 100%;
    max-width: 100%;
    
    @media (min-width: 1200px) {
      margin: 0;
      padding: 0;
    }
  `}
`;
export const SpinContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const AppFooter = styled(Footer)`
  background: white;
  padding: 40px 0;
  width: 100%;
  @media (min-width: 992px) {
    padding: 80px 0;
  }
`;

export const MobileSidebarTrigger = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  width: fit-content;
  position: fixed;
  bottom: 80px;
  right: 16px;
  z-index: 999;
  background: #6a5eea;
  padding: 12px 24px;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 1200px) {
    display: flex;
  }

  svg {
    font-size: 20px;
  }
`;

// Global override for Sider to ensure it hides/shows correctly if not using default breakpoint behavior or if we want custom trigger
/* Note: The Sider "breakpoint='xl'" prop handles hiding, but we leave space if not careful. */
